//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    type: {
      default: 0
    },
    beginTime: {
      default: undefined
    },
    endTime: {
      default: undefined
    },
    disabledDay: {
      default: false
    },
    disabledWeek: {
      default: false
    },
    disabledMonth: {
      default: false
    },
    disabledYear: {
      default: false
    }
  },
  data: function () {
    let currentType = this.type
    let weekOptions = _.map(_.range(0, 11), (t, i, l) => {
      let d = moment().subtract(t, 'week')
      let b = d.startOf('week').add(1, 'days').format('YYYY-MM-DD')
      let e = d.endOf('week').add(1, 'days').format('YYYY-MM-DD')
      // console.log('b', b)
      // console.log('e', e)
      return {value: `${b} ${e}`, label: `${b}到${e}`}
    })
    let monthOptions = _.map([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], (t, i, l) => {
      return {value: t<9 ? `0${t}` : `${t}`, label: `${t}月`}
    })
    let yearOptions = _.map([2018, 2019], (t, i, l) => {
      return {value: `${t}`, label: `${t}年`}
    })
    return {
      currentType: currentType,
      form: {
        day: moment().format('YYYY-MM-DD'),
        week: moment().startOf('week').add(1, 'days').format('YYYY-MM-DD')+' '+moment().endOf('week').add(1, 'days').format('YYYY-MM-DD'),
        month: moment().format('MM'),
        year: moment().format('YYYY')
      },
      weekOptions: weekOptions,
      monthOptions: monthOptions,
      yearOptions: yearOptions
    }
  },
  watch: {
    currentType: {
      handler (val) {
        if (val !== undefined) {
          switch (val) {
            case 0:
              this.handleFormDayChange(this.form.day)
              break
            case 1:
              this.handleFormWeekChange(this.form.week)
              break
            case 2:
              this.handleFormMonthChange(this.form.month)
              break
            case 3:
              this.handleFormYearChange(this.form.year)
              break
            default:
              break
          }
          // console.log('val', val, 'type', this.type)
          if (val !== this.type) {
            this.$emit('update:type', val)
          }
        }
      },
      immediate: true
    },
    'form.day': {
      handler(val) {
        this.handleFormDayChange(val)
      }
    },
    'form.week': {
      handler(val) {
        this.handleFormWeekChange(val)
      }
    },
    'form.month': {
      handler(val) {
        this.handleFormMonthChange(val)
      }
    },
    'form.year': {
      handler(val) {
        this.handleFormYearChange(val)
      }
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {
    handleFormDayChange: function (val) {
      if (val) {
        this.$emit('update:beginTime', val)
        this.$emit('update:endTime', val)
      }
    },
    handleFormWeekChange: function (val) {
      if (val) {
        let a = val.split(' ')
        this.$emit('update:beginTime', a[0])
        this.$emit('update:endTime', a[1])
      }
    },
    handleFormMonthChange: function (val) {
      if (val) {
        let b = `${moment().format('YYYY')}-${this.form.month}-01`
        let e = moment(b).endOf('month').format('YYYY-MM-DD')
        this.$emit('update:beginTime', b)
        this.$emit('update:endTime', e)
      }
    },
    handleFormYearChange: function (val) {
      if (val) {
        let b = `${this.form.year}-01-01`
        let e = moment(b).endOf('year').format('YYYY-MM-DD')
        this.$emit('update:beginTime', b)
        this.$emit('update:endTime', e)
      }
    }
  }
}
